import React from 'react';

function SuccessfulChange() {
    return (
        <div className='d-flex w-100 h-100 text-center justify-content-center align-items-center flex-column'>
            <div>
                <img
                    height={"300px"}
                    src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/SuccessfulPayment.png`}
                />
                <div className='f-20'>
                    All Set!
                </div>
                <div className='font-size-4'>
                    Everything is ready for you.
                </div>
                <div className='font-size-4'>
                    You can go to your workspace to manage your subscription and users.
                </div>
            </div>
        </div>
    );
}

export default SuccessfulChange;